"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Canceled32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M21 15a7 7 0 110 14 7 7 0 010-14zm0 1a6 6 0 100 12 6 6 0 000-12zm2.43 3.34a.496.496 0 01.712.046l.153.177c.19.22.165.538-.042.727l-1.98 1.8 1.945 1.74a.51.51 0 01.043.717l-.204.228a.498.498 0 01-.712.035l-2.032-1.848-2.03 1.848a.498.498 0 01-.646.027l-.066-.062-.204-.228a.51.51 0 01.043-.716l1.944-1.741-1.979-1.8a.518.518 0 01-.042-.727l.153-.177a.496.496 0 01.713-.047l2.115 1.893zM23 3a1 1 0 011 1v9.5a.5.5 0 11-1 0V4H7v19h5.5a.5.5 0 110 1H7a1 1 0 01-1-1V4a1 1 0 011-1h16zm-2.5 10a.5.5 0 01.09.992L20.5 14h-11a.5.5 0 01-.09-.992L9.5 13h11zm0-3a.5.5 0 01.09.992L20.5 11h-11a.5.5 0 01-.09-.992L9.5 10h11zm0-3a.5.5 0 01.09.992L20.5 8h-11a.5.5 0 01-.09-.992L9.5 7h11z" }))); };
var StyledCanceled32 = styled_components_1.default(Canceled32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCanceled32;
var templateObject_1;
//# sourceMappingURL=Canceled32.js.map